/**
 * A19 - nearby / map empty-state when geo filter omits shipping-only shops.
 * ONLINE_ONLY is never plottable; STOREFRONT-without-pin uses generic noCoordinates.
 */

import {
  isOnlineOnlyCustomerPresence,
  parseSalesPointCustomerPresence,
  type SalesPointCustomerPresence,
} from './customerPresence.js';

export type ShippingOnlyGeoOmitItem = {
  readonly customerPresence?: SalesPointCustomerPresence | null | unknown;
};

/** True when the list includes at least one ONLINE_ONLY shop. */
export function directoryIncludesShippingOnly(
  items: readonly ShippingOnlyGeoOmitItem[],
): boolean {
  return items.some((item) =>
    isOnlineOnlyCustomerPresence(
      parseSalesPointCustomerPresence(item.customerPresence),
    ),
  );
}

/**
 * Map / nearby empty should use Shipping-only omit copy when:
 * - zero plottable pins (geo view empty), and
 * - the source list still has ONLINE_ONLY shops that geo omitted.
 */
export function shouldShowShippingOnlyGeoOmitEmpty(input: {
  readonly plottableCount: number;
  readonly items: readonly ShippingOnlyGeoOmitItem[];
}): boolean {
  if (input.plottableCount > 0) {
    return false;
  }
  return directoryIncludesShippingOnly(input.items);
}

/**
 * Browse nearby empty-state note (A19) — same ONLINE_ONLY gate as map.
 * `emptyStateKind === 'nearby'` alone must not show the omit copy.
 */
export function shouldShowBrowseNearbyShippingOnlyOmitNote(input: {
  readonly emptyStateKind: 'default' | 'nearby' | 'favorites';
  readonly plottableCount: number;
  readonly items: readonly ShippingOnlyGeoOmitItem[];
}): boolean {
  if (input.emptyStateKind !== 'nearby') {
    return false;
  }
  return shouldShowShippingOnlyGeoOmitEmpty({
    plottableCount: input.plottableCount,
    items: input.items,
  });
}